const WATERFALLS = [
  {
    name: 'Glen Falls',
    icon: 'ri-water-flash-line',
    description:
      'One of the most popular waterfalls near Highlands, Glen Falls features a series of cascading waterfalls along a scenic forest trail. It\'s a favorite destination for visitors and a great option for those exploring the area with dogs on a leash.',
  },
  {
    name: 'Dry Falls',
    icon: 'ri-drop-line',
    description:
      'A unique waterfall where visitors can walk directly behind the cascade without getting wet. Located just off Highway 64, Dry Falls is easily accessible and makes for a wonderful stop during a pet-friendly Highlands NC visit.',
  },
  {
    name: 'Bridal Veil Falls',
    icon: 'ri-sparkling-line',
    description:
      'A gentle, graceful waterfall accessible via a short walking path from the roadside. One of the most relaxed and low-key waterfall stops in the area, and a peaceful outing that dogs tend to enjoy.',
  },
];

export default function WaterfallsSection() {
  return (
    <section className="bg-[#EDE8E0] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center mb-16">
          <div>
            <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Nature Walks</p>
            <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light mb-6">
              Dog-Friendly<br /><em className="italic">Waterfalls Near Highlands NC</em>
            </h2>
            <p className="text-[#5C5850] font-jost text-sm leading-relaxed">
              The Highlands area is home to some of the most beautiful waterfalls in the Southern Appalachians. Many are easily accessible with leashed dogs and make for a memorable outing. Cabins near waterfalls in Highlands NC are particularly popular among visitors looking to combine nature with a comfortable stay.
            </p>
          </div>
          <div className="rounded-2xl overflow-hidden h-[320px]">
            <img
              src="https://public.readdy.ai/ai/img_res/7c7e5a83e86e39b8c49df775d8e8d120.jpg"
              alt="Glen Falls waterfall near Highlands North Carolina in the Blue Ridge Mountains"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {WATERFALLS.map((wf) => (
            <article key={wf.name} className="bg-white rounded-2xl p-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EDE8E0] mb-5">
                <i className={`${wf.icon} text-[#2D4A3E] text-xl`} />
              </div>
              <h3 className="font-cormorant text-2xl text-[#1A1A18] font-medium mb-4 leading-snug">{wf.name}</h3>
              <p className="text-[#5C5850] text-sm font-jost leading-relaxed">{wf.description}</p>
              <div className="mt-5 flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-information-line text-[#C9A96E] text-sm" />
                </div>
                <span className="text-[#9C9890] text-xs font-jost italic">Dogs welcome on leash</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
